export const CREATE_TYPE = "create";
export const EDIT_TYPE = "edit";
export const OVERRIDE_TYPE = "override";

export const isCreatePage = type => type === CREATE_TYPE;
export const isEditPage = type => type === EDIT_TYPE;
export const isOverridePage = type => type === OVERRIDE_TYPE;
